<template>
  <div class="products-result-base" :style="styles">
    <h1><img class="head-img-3years" src="/static/img/recommend/lp/kurenotori/products/head_your3years_after.png" alt=""></h1>
    <div class="result-base" v-if="this.resultListMod.length > 0">
      <img :src="hououType.image1" alt="" class="main-image">
      <h2><span class="pre-word">{{hououType.text1}}...</span>{{hououType.text2}}</h2>
      <div
        class="block-result-item"
        v-for="(item, idx) in resultListMod"
        :key="`res${idx}`"
      >
        <div class="head-str">
          <img class="year-icon" src="/static/img/recommend/lp/kurenotori/products/year-icon.svg">
          <span class="years">{{ item.headStr }}</span>
        </div>

        <div class="description">
          <h4 v-html="item.text1"></h4>
          <img :src="item.unseiPic" v-if="item.num === 3 && !!item.unseiPic.length">
          <p class="desc-body" v-html="item.text2"></p>
          <p class="point" v-if="item.num !== 3">
            <span class="point-head"><img src="/static/img/recommend/lp/kurenotori/products/ic_point_handsign.svg" alt=""></span>
            <span class="point-words" v-html="item.text3"></span>
          </p>
        </div>

        <div class="kurenotori-messages" v-if="item.num === 3">
          <span class="mess-head">暮れの酉からのメッセージ</span>
          <img class="mess-img" src="/static/img/recommend/lp/kurenotori/products/img_res_kurenotori1.png">
          <p class="mess-body"  v-html="item.text3"></p>
        </div>
      </div>
    </div>
    <div class="regist-birthdate" v-else>
      <p class="error-title">この特集の占いをお楽しみいただくには、<br class="br-pc">以下の情報が必要です。</p>
      <ul>
        <li>・あなたの姓/名</li>
        <li>・あなたの生年月日</li>
      </ul>
      <p class="links">こちらのリンクより、情報のご登録をお願いいたします。</p>
      <a href="/user/account/profile">【占いに使う情報を管理】</a>
    </div>

    <!-- <banner-block /> -->
    <recommend-block-plus
      :recommend-data="standardRecommendData"
      :color-scheme="recommendColorScheme"
    />
  </div>
</template>

<script>
import {BASIC_DATA, DEFAULT_FOOTER_MENULIST } from '@/utvStore/components/recommend/lp/commons'
import moment from "moment";
import * as type from '@/utvStore/store/mutation-types'
import BannerBlock from '../partials/BannerBlock'
import RecommendBlockPlus from '@/utvStore/components/common/RecommendBlockPlus'


export default {
  name: 'ProductsKurenotoriIndex',
  components: {
    RecommendBlockPlus,
    BannerBlock,
  },
  props: {
    resultData: {
      type: Object,
      default: null,
    },
    requireProf: {
      type: Array,
      default: null,
    },
    standardRecommendData: {
      type: Array,
    },
    csrfToken: {
      type: String,
      default() {
        return ''
      }
    },
  },
  data(){
    return {
      regBirthValid: false,
      regBirthErr: '',
      regBirthInit: false,
      regBirthVal: null,
    }
  },
  computed: {
    hououType(){
      return !!this.resultData ? this.resultData.kurenotori_0001_01 : null
    },
    resultList(){
      return !!this.resultData ? this.resultData.kurenotori_0001_02 : null
    },
    formatedBirthdate(){
      return !!this.regBirthVal ? this.regBirthVal.format('YYYY-MM-DD') : ''
    },
    resultListMod() {
      const arr = []
      if (Object.keys(this.resultList).length > 0) {
        Object.keys(this.resultList).forEach(key => {
          const mtc = key.match(/result(\d+)/)
          const num = +mtc[1]
          // const unseiPic = num === 3 ? `/static/img/recommend/lp/kurenotori/products/unsei_pics/img_3year_${this.resultList[key].unsei1}.png` : ''
          const unseiPic = num === 3 ? this.resultList[key].image1 : ''
          let headStr = ''
          switch (num) {
            case 1:
              headStr = '2022-2023年'
              break
            default:
              headStr = `${2022 + num}年`
          }
          arr.push({
            key: key,
            num: num,
            unseiPic: unseiPic,
            headStr: headStr,
            ...this.resultList[key]
          })
        })
        arr.sort((a, b) => {
          if (a.key < b.key) return -1;
          if (a.key > b.key) return 1;
          return 0;
        })

        // テンプレートように変数を移動
        arr[2].text3 = arr[2].text2
        arr[2].text2 = arr[2].text1
        arr[2].text1 = ''
      }
      return arr
    },
    counselorInfos(){
      return BASIC_DATA.kurenotori
    },
    recommendColorScheme() {
      return {
        keyColor: this.counselorInfos.colorScheme.keyColor,
      }
    },
    styles(){
      return {
        '--key-color': this.counselorInfos.colorScheme.keyColor,
        '--mess-bg': this.counselorInfos.colorScheme.messBg,
      }
    },
  },
  created() {
    this.$store.dispatch(type.SET_COLOR_SCHEME, this.counselorInfos.colorScheme)
  },
  mounted() {
    console.log('hououType: %O', this.hououType)
    console.log('resultList: %O', this.resultList)
    console.log('resultListMod: %O', this.resultListMod)
  },
  methods: {
    onBirthdayChange(val){
      if(!this.regBirthInit){
        this.regBirthInit = true
      }else {
        if (val.length === 8) {
          const y = val.substring(0, 4)
          const m = val.substring(4, 6)
          const d = val.substring(6, 8)

          const now = new moment()
          const mom = new moment([+y,+m-1,+d])

          if (mom.isBetween('1940-01-01', now, null, '[)') && mom.isValid()){
            this.regBirthErr = ''
            this.regBirthVal = mom
            this.regBirthValid = true
          }else{
            this.regBirthErr = '正しい日付を入力してください'
            this.regBirthValid = false
            this.regBirthVal = null
          }
        } else {
          this.regBirthErr = ''
          this.regBirthValid = false
          this.regBirthVal = null

        }
      }
    },
    onRegBirthSubmitClick(){
      this.$refs.regbirth.submit()
    }
  },
}</script>

<style scoped lang='scss'>
@import "../../../../../../sass/commons/commonVariables.scss";

$tori_navy:#142254;


/deep/ {
  img {
    max-width: 100%;
    display: block;
  }
  p {
    margin: 0 auto 24px;
  }
  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }
}
.products-result-base {
  background: url(/static/img/recommend/lp/kurenotori/bg_tori_3nen.png) repeat-y;
  background-size: 100% auto;
  padding-top: 40px;
  h1 {
    margin: 0 auto 24px;
  }
  .result-base {
    background: white;
    width: calc(100% - 36px);
    margin: 0 auto 24px;
    padding: 15px;
    padding-bottom: 24px;
    border: 1px solid $tori_navy;
    border-radius: 10px;
    margin-bottom: 60px;
    h1 {
      margin: 0;
      padding-top: 40px;
    }
    h2{
      font-weight: 600;
      font-size: 18px;
      line-height: 24px;
      text-align: center;
      color: $tori_navy;
      margin: 16px 0 24px;
      .pre-word {
        display: block;
        font-size: 0.8em;
      }
    }
    h4{
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 16px;
      color: $tori_navy;
      margin: 0;
      margin-bottom: 8px;
    }
  }
}
.desc-body{
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
  line-height: 22px;
  color: $tori_navy;
}
.point{
  background: #FFFBE3;
  padding:12px;
}
.point-head{
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
}
.point-words{
  font-weight: 300;
  font-size: 14px;
  line-height: 22px;
  color: $tori_navy;
}

.head-str {
  background-color: white;
  position: absolute;
  top: 0;
  left: 15px;
  padding-bottom: 22px;
}
.year-icon{
  position: absolute;
  z-index: 2;
  top: -2px;
  left: 2px;
}

.block-result-item{
  padding-top: 45px;
  position: relative;

  img{
    margin-bottom: 8px;
  }
}

.description{
  background: url(/static/img/recommend/lp/kurenotori/products/dotline1.svg) repeat-y;
  background-color: #ffffff;
  background-size: 13% 6px;
  padding-left: 40px;
  padding-top: 0;
  position: relative;
  @include mq('w580') {
    background-size: 9% 6px;
    padding-left: 48px;
  }
}

.kurenotori-messages{
  background: #F3FEFF;
  padding: 24px 16px;
  .mess-head{
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    text-align: center;
    color: $tori_navy;
    margin-bottom: 24px;
    display: block;
  }
  .mess-img{
    margin: auto;
    margin-bottom: 16px;
    width: 170px;
    height: 170px;
  }
  .mess-body{
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 22px;
    color: $tori_navy;
    margin: 0;
  }
}
.years {
  padding: 6px;
  background: $tori_navy;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 12px;
  color: #fff;
  width: 161px;
  display: block;
  position: relative;
  padding-left: 32px;
  &:after{
    position: absolute;
    content: "";
    width: 10px;
    height: 11px;
    right: 0px;
    top: 0px;
    border-style: solid;
    border-color:  $tori_navy white  $tori_navy transparent;
    border-width: 12px 8px 12px 0px;
  }
}

.head-img-3years{
  width: 232px;
  margin: auto;
  margin-bottom: 24px;
}

.regist-birthdate {
  padding: 24px 24px 32px;
  background: var(--mess-bg);
  border-radius: 10px;
  width: 88vw;
  margin: auto;
  margin-bottom: 30px;
  text-align: center;
  color: var(--key-color);
  font-size: 16px;
  @include mq('w580') {
    width: 80%;
  }
  .br-pc {
    display: none;
    @include mq('w580'){
      display: inline;
    }
  }

  .error-title {
    font-weight: bold;
    margin-bottom: 16px;
  }
  .links {
    font-weight: bold;
    margin-bottom: 16px;
  }
  ul {
    margin-bottom: 12px;
    li {
      color: red;
      font-size: 16px;
      font-weight: bold;
      text-align: left;
      margin: 0 auto;
      padding-left: 20vw;
      @include mq('w580') {
        width: 50%;
        padding: 0;
      }
    }
  }
  a {
    color: #547fe4;
    text-decoration: none;
    border-bottom: 1px solid red;
    padding-bottom: 3px;
    font-weight: bold;
  }

}

</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Products/kurenotori/fortunes/ProductsResult01.vue